module.exports = __webpack_public_path__ + "static/grouped-column-4bd54c7ba1dc1f9e2d431920c27fba34.png";